import { useContext, useEffect } from "react";
import { AppContentAPIContext } from "@/contexts/appContent/appContentHooks";
import { useConfetti } from "@/contexts/confetti/useConfetti";

export function useSectionCompleteConfetti() {
    const api = useContext(AppContentAPIContext);
    const confetti = useConfetti();

    useEffect(() => {
        if (!api) return;
        return api.subscribeToCompletedSectionCount(() => {
            confetti?.requestConfetti();
        });
    }, [api, confetti]);
}
